module.exports = __webpack_public_path__ + "img/mx.mx479622e.svg";